import { CSSProperties } from 'react'

const styles: {
  container: CSSProperties
  chevron: CSSProperties
  seasonEpisodes: CSSProperties
} = {
  container: {
    width: '100%',
    cursor: 'pointer',
  },
  chevron: {
    fontSize: 14,
    color: '#aaaaaa',
    width: 14,
    flexShrink: 0,
  },
  seasonEpisodes: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 16,
    borderLeft: '1px solid #5b5b5b',
  },
}

export default styles
